interface SectionHeadProps {
  eyebrow: string;
  title: React.ReactNode;
  lede?: string;
  align?: 'center' | 'left';
}

export function SectionHead({ eyebrow, title, lede, align = 'center' }: SectionHeadProps) {
  const isLeft = align === 'left';
  return (
    <div className={`max-w-[720px] mb-16 ${isLeft ? '' : 'text-center mx-auto'}`}>
      <div className="font-mono text-[12px] tracking-widest uppercase text-violet-600 mb-4 font-medium">
        {eyebrow}
      </div>
      <h2 className="font-display font-extrabold text-ink-900 mb-5 text-[clamp(32px,5vw,64px)] leading-none tracking-[-0.035em]">
        {title}
      </h2>
      {lede && <p className={`text-[18px] leading-snug text-ink-600 max-w-[60ch] ${isLeft ? '' : 'mx-auto'}`}>{lede}</p>}
    </div>
  );
}
